export default "__VITE_ASSET__B7YCWq2o__"